import { render } from "./ModuleDescription.vue?vue&type=template&id=3739c570"
import script from "./ModuleDescription.vue?vue&type=script&lang=js"
export * from "./ModuleDescription.vue?vue&type=script&lang=js"

import "./ModuleDescription.vue?vue&type=style&index=0&id=3739c570&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__